/**
 * Created by mqamhieh on 11/16/16.
 */
(function (app) {

    app.controller("JobApplyController", [
        "$scope", "$rootScope", "hTransitions", "$state", "$stateParams", "$filter", "$modal", "JobDetailsBus", "hUser", "hEvent", "jobApplyAPI", "googleMaps", "Upload", "registrationApi", "$location", "localize", "krtMarketingTrackingService", 'positionsDataService', 'httpHelper', 'chatBotService','googleTagManagerTrackingService', 'appLayoutViewService', '$element', 'googleSearchService', 'deviceChecker', 'jobApplyFactory', 'outmatchAssessmentService',
        function ($scope, $rootScope, hTransitions, $state, $stateParams, $filter, $modal, JobDetailsBus, hUser, hEvent, jobApplyAPI, googleMaps, Upload, registrationApi, $location, localize, krtMarketingTrackingService, positionsDataService, httpHelper, chatBotService, googleTagManagerTrackingService, appLayoutViewService, $element, googleSearchService, deviceChecker, jobApplyFactory, outmatchAssessmentService) {

            var jobId = parseInt($stateParams.job_id);
            var job_referrer_id = $stateParams.job_referrer_id || null;
            var referrer = $stateParams.utm_source || null;
            var social_media_channel = $stateParams.social_media_channel || null;
            let talent_scout_code_id = $stateParams.talent_scout_code_id || null;
            var viewOnly = ($stateParams['view_only'] && $stateParams['view_only'].toLowerCase() === 'true');
            var harriApplyFLow = ($stateParams['h_apply_flow'] && $stateParams['h_apply_flow'].toLowerCase() === 'true');
            var applicantFirstName = $stateParams['first_name'] || "";
            var applicantLastName = $stateParams['last_name'] || "";
            var forms = new FormGroup();
            var applicationDetails;
            var draftedBeforeApply;
            var resetPasswordCode;
            var stateToGoAfterDiscard;
            var paramsToGoAfterDiscard;
            var discardApproved;
            var retryCounter = 0;
            var MAX_RETRY_COUNT = 1;
            var dFCarriEvent;
            $scope.returnUrl = $location.$$url;
            $scope.isCheckingLoginValidation = false;
            self.OUTMATCH_HARVER_CANDIDATE_STATUS = outmatchAssessmentService.OUTMATCH_HARVER_CANDIDATE_STATUS;
            const JOB_APPLY_SUBMIT_ٍFLOWS = {
                EEO_SCREENING: 'EEO_SCREENING',
                BULK_APPLY_SCREENING: 'BULK_APPLY_SCREENING'
            }
            const MASSACHUSETTS_STATE_CODE = 'MA';

            setTimeout(function () {
                $(".close")[0].focus();
            }, 500);

            if (typeof HThirdPartyManager !== 'undefined') {
                HThirdPartyManager.register(HStoragePolicyManager.Categories.ANALYTICS, function() {
                    krtMarketingTrackingService.trackApplicationStart(jobId, $stateParams.pjt);
                    googleTagManagerTrackingService.initForJob(jobId, $stateParams.pjt);
                    
                    
                    if (typeof(__clickIq) !== 'undefined') {
                        try {
                            __clickIq.Click("https://api.clickiq.co.uk", publicConfiguration.MandBClickIQClientKey, jobId);
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }, 'application_start_tracking');
            }

            

            if ($stateParams.code) {
                if (!hUser.isLoggedIn()) {
                    resetPasswordCode = $stateParams.code;
                }
                else {
                    $state.go('.', { code: '' }, { reload: false });
                }
            }

            $scope.formsToFill = [];
            $scope.applicationForms = {};

            const initRecaptcha = () => {
                return hRecaptchaUtil.initRecaptchaScript()
                    .then(() => {
                        $scope.$digest();
                    })
                    .catch((err) => {
                        console.error(err)
                    });
            };

            var getFormsAsCodeString = function () {
                var formsCodes = [];
                var optionalFormsCodes = [];

                for (var i in $scope.formsToFill) {
                    if (!$scope.formsToFill[i].is_optional) {
                        formsCodes.push($scope.formsToFill[i].code);
                    }
                    else {
                        optionalFormsCodes.push($scope.formsToFill[i].code);
                    }
                }

                return JSON.stringify(formsCodes).replace(/"/g, '').replace(/,/g, ', ') + "~" + JSON.stringify(optionalFormsCodes).replace(/"/g, '').replace(/,/g, ', ') ;
            };

            $scope.trackEvent = function (eventName, data, callback) {
                data = data || {};

                var analyticsData = $.extend({
                    category: 'job_apply'
                }, data);

                hEvent.track(eventName, analyticsData, callback);
            };

            var startApplication = function () {
                runTasks([
                    checkBeforeApply,
                    checkATS,
                    checkApplyMode,
                    showApply,
                    checkUser,
                    doBeforeApplication,
                    checkAppRequirements,
                    checkEEOQuestionsSettings,
                    doApply,
                    doAfterApply
                ]);
            };

            var endApplication = function (status, appId, applyDate) {

                // Set discardApproved to true, always state transition without confirmation
                discardApproved = true;

                if (status === JobDetailsBus.SUCCESS &&
                    ($scope.jobDetails?.brand?.public_services?.includes("EQUAL_EMPLOYMENT_OPPORTUNITY") ||
                        $scope.jobDetails?.brand?.public_services?.includes("EEO_REPORT"))) {
                    const brandId = $scope.jobDetails.brand.id;

                    if (
                        $scope.jobDetails?.brand?.public_services?.includes("EEO_REPORT") &&
                        $scope.applicationEEOForm?.id &&
                        $scope.jobDetails?.job?.type_code !== "TALENT_POOL"
                    ) {
                        handleOutmatchAssessment(brandId, appId, JOB_APPLY_SUBMIT_ٍFLOWS.EEO_SCREENING);
                    } else if (
                        $scope.jobDetails?.brand?.public_services?.includes("EQUAL_EMPLOYMENT_OPPORTUNITY") &&
                        $scope.eeoForms?.length
                    ) {
                        handleOutmatchAssessment(brandId, appId, JOB_APPLY_SUBMIT_ٍFLOWS.BULK_APPLY_SCREENING);
                    }
                    else {
                        doEndApplication(status, appId, applyDate);
                    }
                } else {
                    doEndApplication(status, appId, applyDate);
                }
            };

            const handleOutmatchAssessment = (brandId, appId, nextFlow) => {
                if (nextFlow === JOB_APPLY_SUBMIT_ٍFLOWS.EEO_SCREENING) {
                    handleEEOScreening(brandId, appId);
                } else if (nextFlow === JOB_APPLY_SUBMIT_ٍFLOWS.BULK_APPLY_SCREENING) {
                    handleBulkApplyScreening(brandId, appId);
                }
            };

            const handleEEOScreening = (brandId, appId) => {
                $state.go("screening", {
                    brand_id: brandId,
                    job_id: jobId,
                    application_id: appId,
                    screening_forms_id: $scope.applicationEEOForm?.id,
                    form_type: "V2"
                });
            }

            const handleBulkApplyScreening = (brandId, appId) => {
                $state.go("BulkApplyScreening", {
                    brand_id: brandId,
                    job_id: jobId,
                    application_id: appId,
                    form_type: "EQUAL_EMPLOYMENT_OPPORTUNITY"
                });
            }

            let doEndApplication = function(status, appId, applyDate) {
                var state = stateToGoAfterDiscard || '^';
                var params = paramsToGoAfterDiscard || {};

                const shouldReload = deviceChecker.isMobile();
                $state.go(state, params, { reload: shouldReload && status !== JobDetailsBus.SUCCESS });

                setTimeout(function () {
                    JobDetailsBus.onJobApplyFinish(status, appId, applyDate, jobId);
                    JobDetailsBus.onJobApplyUpdate(status, appId, applyDate, jobId);
                }, 500);

                if (hUser.data.user.status === "DRAFT_NO_PASSWORD" && $scope.jobDetails.brand.public_services && $scope.jobDetails.brand.public_services.indexOf("NO_PASSWORD_QUICK_APPLY") > -1) {
                    JobDetailsBus.setIsNoPassword($scope.jobDetails.job.id, true);
                }
            }

            var logoutUser = function () {
                var fullUrl =  window.location.href,
                    applyIndex = fullUrl.indexOf('/apply'),
                    redirectUrl = fullUrl.substr(0, applyIndex);

                hLoginManager.signOut(redirectUrl);
            };

            var handleErrors = function (section, error) {

                var showError = false;
                console.error(section, error);

                if (error && error.data && error.data.code && (retryCounter++ < MAX_RETRY_COUNT)) {
                    switch (error.data.code) {
                        case "MISSING_MANDATORY_DATA":
                            $scope.formsToFill = [];
                            $scope.applicationForms = [];
                            runTasks([
                                doBeforeApplication,
                                checkAppRequirements,
                                doApply,
                                doAfterApply
                            ]);
                            break;

                        case 'EXPIRED_JOB':
                        case 'INVALID_JOB':
                            hAlert(
                                $filter("translate")("Invalid job"),
                                error.data.message,
                                function () {
                                    endApplication(JobDetailsBus.EXPIRED);
                                }
                            );
                            break;
                        case jobApplyFactory.ERRORS.USER_ALREADY_EXISTS_ON_TALENT_POOL:
                            hAlert(
                                $filter("translate")("User already exist"),
                                error.data.message,
                                function () {
                                    endApplication(JobDetailsBus.APPLIED);
                                }
                            );
                            break;
                        default:
                            showError = true;
                    }
                }
                else {
                    showError = true;
                }

                if (showError && error.data?.data?.code) {
                    if (error.data.data.code === 'USER_NOT_MAPPED') {
                        hAlert(
                            $filter('translate')('Your Harri account is nearly ready.'),
                            Utils.humanizeoAuthErrorResponse(error.data.data.code),
                            function () {
                                hLoginManager.signOut('/user/signup');
                            }
                        );
                    } else if (error.data.data.code === 'CAN_NOT_APPLY_TO_TALENT_POOL_JOB') {
                        hLog("JOB_APPLY", section, error);
                        hAlert(
                            $filter("translate")("Already applied"),
                            error.data.data.message,
                            function () {
                                endApplication(JobDetailsBus.APPLIED);
                            }
                        );
                    }
                    else if (error.data.data.code === jobApplyFactory.ERRORS.USER_ALREADY_APPLIED) {
                        $scope.formsToFill = [];
                        $scope.applicationForms = [];
                        delete $scope?.jobDetails?.job?.application_id;
                        runTasks([
                            doBeforeApplication
                        ]);
                        delete $scope.processing;
                    } else if (error.data.data.code === jobApplyFactory.ERRORS.USER_ALREADY_EXISTS_ON_TALENT_POOL) {
                        hLog("JOB_APPLY", section, error);
                        hAlert(
                            $filter("translate")("Already applied"),
                            error.data.data.message,
                            function () {
                                endApplication(JobDetailsBus.APPLIED);
                            }
                        );
                    } else if (error.data.data.code !== 'USER_HAS_NO_EMAIL') {
                        hLog("JOB_APPLY", section, error);
                        hAlert(
                            $filter("translate")("Oops, something went wrong"),
                            $filter("translate")("If the problem persists after reloading the page, please contact " +
                                "<a href='/redirect-to-support' target='_blank'>Harri Support</a>" +
                                "."),
                            function () {
                                window.location = window.location;
                            }
                        )
                    }
                }
            };

            $scope.saveAsDraft = function () {
                var promises = [];

                for (var i in $scope.formsToFill) {
                    var formCode = $scope.formsToFill[i].code;
                    var form = $scope.applicationForms[formCode];

                    if (form) {
                        if (formCode != 'RESUME'
                            && formCode != 'PROFILE_IMAGE'
                            && (
                                formCode == 'SCREENING_FORM'
                                || formCode == 'AVAILABILITY_MATRIX'
                                || form.validator.validateWithoutError()
                            )) {
                            promises.push(form.save());
                        }
                    }
                }

                $q.all(promises)
                    .then(function (data) {
                        endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                    }, function (error) {
                        handleErrors("SAVE_DRAFT", error);
                    });

                $scope.trackEvent('draft', { 'label': getFormsAsCodeString() });
            };

            $scope.confirmLeavingHarri = function () {
                $scope.confirmDiscard();
                $scope.trackEvent('ats_apply', { 'label': $scope.jobDetails['job'].id });
            };

            $scope.confirmDiscard = async () => {
	            if (applicationDetails) {
                    var foundAppDocs = _.find($scope.formsToFill,function (element) {
                        return (element.code === 'APPLICATION_DOCUMENT')
                    });
                    const appDocsForm = forms.getForms().find(form => form.name === 'application_document_upload_form');
                    if (!draftedBeforeApply) {
                        const isLoggedIn = hUser.isLoggedIn();
                        if (isLoggedIn) {
                            HStorageManager.remove({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'placeholder_token'
                            });
                        }
                        const placeholderToken = HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'placeholder_token'
                        });

                        if ($scope.applicationForms['RESUME']?.data.files.length > 0) {
                            try {
                                await JobApplicationAPI.deleteResume(applicationDetails.id, placeholderToken);
                            } catch (error) {
                                handleErrors("DELETE_RESUME", error);
                                endApplication(JobDetailsBus.DISCARDED);
                                return;
                            }
                        }

                        if (foundAppDocs && appDocsForm?.app_doc_details?.application_media_id) {
                            try {
                                await JobApplicationAPI.deleteApplicationDocuments(applicationDetails.id, placeholderToken);
                            } catch (error) {
                                handleErrors("DELETE_APPLICATION_DOCUMENT", error);
                                endApplication(JobDetailsBus.DISCARDED);
                                return;
                            }
                        }

                        try {
                            await JobApplicationAPI.deleteApp(applicationDetails.id, placeholderToken);
                        } catch (error) {
                            handleErrors("DELETE_APP", error);
                            endApplication(JobDetailsBus.DISCARDED);
                            return;
                        }

                        $scope.jobDetails.job.application_id = null;
                        endApplication(JobDetailsBus.DISCARDED);
		            } else {
                        if ($scope.applicationForms['RESUME'] && $scope.applicationForms['RESUME'].data.files.length > 0) {
                            JobApplicationAPI.deleteResume(applicationDetails.id)
                                .then(function () {
                                    endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                                }, function (error) {
                                    handleErrors("DELETE_RESUME", error);
                                    endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                                });
                        } else {
                            endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                        }
                        if (foundAppDocs && appDocsForm?.app_doc_details?.application_media_id) {
                            JobApplicationAPI.deleteApplicationDocuments(applicationDetails.id)
                                .then(function () {
                                    endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                                }, function (error) {
                                    handleErrors("DELETE_APPLICATION_DOCUMENT", error);
                                    endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                                });
                        } else {
                            endApplication(JobDetailsBus.DRAFTED, applicationDetails.id);
                        }
		            }

                    $scope.trackEvent('discard', { 'label': getFormsAsCodeString() });
	            }
	            else {
		            endApplication(JobDetailsBus.DISCARDED);
	            }
            };

            $scope.cancelApplication = function () {
                if (applicationDetails && !$scope.isApplied && !$scope.userHasNoEmail) {
                    $scope.draftedBeforeApply = draftedBeforeApply;

                    if (($scope.jobDetails.brand.public_services && $scope.jobDetails.brand.public_services.indexOf("NO_PASSWORD_QUICK_APPLY") > -1) || !hUser.isLoggedIn()) {
                        CANCEL_MODAL_SELECTOR = "#job_apply_no_password_cancel";
                    } else {
                        CANCEL_MODAL_SELECTOR = "#" +
                            "job_apply_cancel";
                    }

                    $(CANCEL_MODAL_SELECTOR)
                        .modal('show')
                        .on('hide.bs.modal', function () {
                            stateToGoAfterDiscard = null;
                            paramsToGoAfterDiscard = null;
                        });

                    // This digest has no meaning but to try fixing an issue that QA's claim to exist
                    // HARRI-9400
                    setTimeout(function () {
                        setTimeout(function () {
                            $(CANCEL_MODAL_SELECTOR).find('.discard')[0].focus();
                        },500);
                        $scope.$digest();
                    }, 100);
                }
	            else {
                    endApplication(JobDetailsBus.DISCARDED);
                }
            };

            $scope.hideConfirmation = function () {
                $(CANCEL_MODAL_SELECTOR)
                    .modal('hide');
            };

            var onModalExit = function (event) {
                if (event.namespace == 'bs.modal') {
                    if (applicationDetails) {
                        event.preventDefault();
                        $scope.cancelApplication();
                        return false;
                    }
                    else {
                        endApplication(JobDetailsBus.DISCARDED);
                    }
                }
            };

            var prepareApplicationForms = function (applicationId) {
                $scope.formsToFill.forEach(function (options){
                    var formOptions = options;
                    var formCode = formOptions.code;
                    var form = null;
                    switch (formCode) {
                        case 'PHONE':
                            form = new BasicInfoForm($scope, hUser);
                            form.templateURL = "../modules/hforms/basic_info/views/basic_info_form.html";
                            form.viewTitle = $filter("translate")("User information");
                            options.rank = 13;
                            break;
                        case 'JOB_APPLY_DISCLAIMER':
                            form = new JobApplyDisclaimerForm($scope);
                            form.setDisclaimers(applicationDetails.disclaimers);
                            form.templateURL = "../modules/hforms/job_apply_disclaimer/views/job_apply_disclaimer_form.html";
                            $scope.applicationForms["JOB_APPLY_DISCLAIMER"] = form;
                            $scope.hasJobApplyDisclaimer = true;
                            break;
	                    case 'AVAILABILITY_MATRIX':
		                    form = new AvailabilityMatrixForm($scope, applicationId);
		                    form.templateURL = "../modules/hforms/availability_matrix/views/availability_matrix_form.html";
		                    form.viewTitle = $filter("translate")("What days of the week are you able to commit to") + "?";
		                    form.load(applicationDetails.availability_matrix);
                            options.rank = 5;
                            break;
                        case 'RESUME':
                            form = new ResumeUploadForm($scope, Upload, applicationId, hUser, $scope.jobDetails.job);

                            var resume = applicationDetails.resume || applicationDetails.user_resume;
                            if (resume) {
                                if (applicationDetails.user_resume) {
                                    resume.needs_assign = true;
                                }

                                form.data.files = [
                                    {
                                        name: (resume.display_name || 'resume') + '.' + resume.extension,
	                                    extension: resume.extension,
	                                    file_name: resume.file_name,
                                        id: resume.id,
                                        href: resume.href,
                                        needs_assign: resume.needs_assign
                                    }
                                ];
                            }

                            form.setRequired(!formOptions.is_optional);
                            form.allowParse(true);
                            form.templateURL = "../modules/hforms/resume_upload/views/resume_upload_form.html";
                            form.getParsedData = getParsedData;
                            options.rank = 1;
                            break;
                        case 'APPLICATION_DOCUMENT':
                            form = new ApplicationDocumentUploadForm($scope, Upload, applicationId, hUser, $scope.jobDetails.brand, angular.copy(formOptions.application_document), jobApplyAPI);

                            var application_media_documents = applicationDetails.application_media_documents;
                            if (application_media_documents) {
                                var result = application_media_documents.filter(function (appMediaDocs) {
                                    return(appMediaDocs.application_document.id === formOptions.application_document.id);
                                });

                                if (result.length > 0) {
                                    var media = result[0];
                                    form.app_doc_details.application_media_id = media.application_media.id;
                                    form.data.files = [
                                        {
                                            name: media.application_media.display_name ,
                                            extension: media.application_media.extension,
                                            file_name: media.application_document.name,
                                            id: media.application_document.id,
                                            href: media.application_media.href
                                        }
                                    ];
                                }
                            }

                            form.setRequired(!formOptions.is_optional);
                            form.templateURL = "../modules/hforms/application_document_upload/views/application_document_upload_form.html";
                            options.rank = 10;
                            break;
                        case 'WORK_HISTORY':
                            form = new ExperienceForm($scope, hUser.getUser().id, googleMaps, positionsDataService);
                            form.templateURL = "../modules/hforms/experience/views/experience_form.html";
                            form.viewTitle = $filter("translate")("Work experience");
                            form.type = form.TYPES.JOB_APPLICATION;
                            options.rank = 6;
                            break;
                        case 'WORK_ELIGIBILITY':
                            form = new WorkEligibilityForm($scope, applicationDetails.work_eligibility.options, applicationId);
                            form.templateURL = "../modules/hforms/work_eligibility/views/work_eligibility_form.html";
                            form.viewTitle = $filter("translate")("Are you eligible to work in the UK and able to provide ‘right to work’ documents?");
                            options.rank = 3;
                            break;
                        case 'EDUCATION':
                            form = new EducationForm($scope, hUser.getUser().id, googleMaps);
                            form.setIsEducationDatesMandatoryFlag($scope.isEducationDatesMandatory);
                            form.templateURL = "../modules/hforms/education/views/education_form.html";
                            form.viewTitle = $filter("translate")("Add education");
                            form.type = 'job_application';
                            form.load(hUser.getUser().id);
                            options.rank = 8;
                            break;
                        case 'SKILLS':
                            form = new SkillsForm($scope, registrationApi, null, hUser);
                            form.templateURL = "../modules/hforms/skills/views/skills_form.html";
                            form.viewTitle = $filter("translate")("Add skills");
                            options.rank = 7;
                            break;
                        case 'AVAILABILITY':
                            form = new AvailabilityForm($scope);
                            form.templateURL = "../modules/hforms/availability/views/availability_form.html";
                            form.viewTitle = $filter("translate")("When are you available to work?");
                            options.rank = 4;
                            break;
                        case 'REFERENCES':
                            form = new ReferencesForm($scope, hUser, 'JOB_APPLY');
                            form.templateURL = "../modules/hforms/references/views/application_references_form.html";
                            form.viewTitle = $filter("translate")("Add references");
                            options.rank = 9;
                            break;
                        case 'USER_VERIFIED_LOCATION':
                            form = new VerifiedLocationForm($scope, applicationDetails.user_location, googleSearchService, hUser, googleMaps);
                            form.templateURL = "../modules/hforms/verified_location/views/verified_location_form.html";
                            options.rank = 12;
                            break;
                        case 'LOCATION':
                            form = new JobPreferredLocationForm($scope, applicationId, applicationDetails.job_locations);
                            form.templateURL = "../modules/hforms/job_preferred_location/views/job_preferred_location_form.html";
                            form.viewTitle = $filter("translate")("Which location would you prefer to work at? (Check all that applies)");
                            options.rank = 11;
                            break;
                        case 'SCREENING_FORM':
                            var screening_form = _.find(applicationDetails.screening_forms, function (form) {
                                return !form.type || form.type !== 'EEO';
                            });

                            form = new ScreeningAnswerForm($scope, screening_form, applicationId, jobId, 'V2');
                            form.templateURL = "../modules/hforms/screening_answer/views/screening_answer_form.html";
                            form.viewTitle = $filter("translate")("Application questions");
                            options.rank = 2;
                            break;
                        case 'PROFILE_IMAGE':
                            form = new ProfilePhotoForm($scope, $scope.placeholderUserId, 'SINGLE_APPLY');
                            form.templateURL = "../modules/hforms/profile_photo/views/profile_photo_form.html";
                            form.viewTitle = $filter("translate")("Profile photo");
                            break;
                        case 'E_VERIFY':
                            break;
                        default:
                            console.error("Couldn't find form with code:", formCode);
                    }
                    if (form) {
                        if (formCode == 'APPLICATION_DOCUMENT'){
                            $scope.applicationForms["APPLICATION_DOCUMENT"+"_"+formOptions['application_document']['id']] = form;
                        } else {
                            $scope.applicationForms[formCode] = form;
                        }
                        form.type = 'job_application';
                        forms.addForm(form);
                    }
                });

                checkResumeRequirements();
            };

            var checkBeforeApply = function (next) {
                JobDetailsBus.getJob(jobId, $stateParams.pjt)
                    .then(function (jobDetails) {
                        $scope.jobDetails = jobDetails;
                        $scope.isJobLocationMassachusetts = jobDetails.job.JobLocation.find(location => location?.State?.code === MASSACHUSETTS_STATE_CODE);
                        var profileImage;
                        var rectangleProfileImage;
                        if ($scope.jobDetails.brand.BrandMedia) {
                            profileImage = _.findWhere($scope.jobDetails.brand.BrandMedia, {'type': 'profile_image'});
                            rectangleProfileImage = _.findWhere($scope.jobDetails.brand.BrandMedia, {'type': 'rectangle_profile_image'});
                        }
                        $scope.brandMedia = profileImage;
                        var theme = {
                            scheme_settings: $scope.jobDetails.brand.scheme_settings,
                            profile_image: profileImage || null,
                            rectangle_profile_image: rectangleProfileImage || null,
                        };

                        if (theme.scheme_settings) {
                            let headerColor = theme.scheme_settings?.career_portal_banner_color || theme.scheme_settings?.accent_color || '#0088DD';
                            document.documentElement.style.setProperty('--header-banner', headerColor);
                        } else {
                            document.documentElement.style.setProperty('--header-banner', '#0088DD');
                        }

                        appLayoutViewService.updateBrandTheme(theme, 'apply_modal_theme', $element.find('.job_apply').context);

                        if ($scope.jobDetails.job.status != 'PUBLISHED' && $scope.jobDetails.job.type_code !== "TALENT_POOL") {
                            hAlert(
                                $filter("translate")("Expired job"),
                                $filter("translate")("This job post has expired")
                            );
                            endApplication(JobDetailsBus.EXPIRED);
                            return;
                        }

                        if (!$scope.jobDetails.job.application_id) {
                            hUser.getUserLocation()
                                .then(function (userLocation) {
                                    var jobLocationConfirmed = HStorageManager.get({
                                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                        key: 'job_distance_{{id}}',
                                        variables: {
                                            id: jobId
                                        }
                                    });

                                    if (!jobLocationConfirmed) {
                                        var jobLocation = jobDetails.job.JobLocation && jobDetails.job.JobLocation[0] && jobDetails.job.JobLocation[0].Location;
                                        if (userLocation && jobLocation) {
                                            var distance = Utils.getDistanceFromLatLonInMiles(userLocation.lat, userLocation.lon, jobLocation.latitude, jobLocation.longitude);

                                            if ($scope.jobDetails.brand.warnings_settings && !($scope.jobDetails.brand.warnings_settings.job_location_range) && distance > 100) {
                                                showLocationWarning(jobLocation, distance, function () {
                                                    next();
                                                });

                                                return;
                                            }
                                        }
                                    }

	                                next();

                                }, function () {
                                    next();
                                });
                        }
                        else {
	                        next();
                        }
                    });
            };

            var checkATS = function (next) {
                if ($scope.jobDetails.job.ats_url) {
                    var invalidATSURL = /harri.com/.test($scope.jobDetails.job.ats_url) ;

                    if (!invalidATSURL) {
                        $("#ats_leaving_harri")
                            .modal("show")
                            .on("hide.bs.modal", onModalExit);
                    }
                    else {
	                    next();
                    }
                }
                else {
	                next();
                }
            };

            var checkApplyMode = function (next) {
                if (!viewOnly) {
                    if (harriApplyFLow) {
                        next();
                    } else if ($scope.jobDetails.job.type_code !== "TALENT_POOL") {
                        chatBotService.getJobApplyMode($scope.jobDetails.brand.id, $scope.jobDetails.job.Position.code)
                            .then(function (mode) {
                                if (mode === 'CARRI_ONLY') {
                                    var payload = {
                                        job_id: jobId,
                                    };
                                    chatBotService.triggerCarriJobApply('apply_for_specific_job', payload);
                                    dFCarriEvent = chatBotService.on("df-carri-event", function () {
                                        $state.go('^', {}, {reload: false});
                                    });
                                } else {
                                    next();
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    } else {
                        next();
                    }
                }
            };

            var showApply = function (next) {
                if (hUser.data.user && (['NO_PASSWORD', 'DRAFT_NO_PASSWORD'].indexOf(hUser.data.user.status) > -1)) {
                    logoutUser();
                    if ($stateParams.job_id) {
                        endApplication(JobDetailsBus.DISCARDED);
                    }
                } else {
                    $(APPLY_MODAL_SELECTOR)
                        .on('hide.bs.modal', onModalExit)
                        .modal("show");

                    next();
                }

            };

            $scope.logoutUser = () => {
                hUser.logout();
                hLoginManager.signOut();
            }

            let getLoggedInUserDetails = async () => {
                $scope.userProfileDetails = {
                    userId: hUser.data.user.id,
                    firstName: hUser.data.user.first_name,
                    lastName: hUser.data.user.last_name,
                };
                try {
                    const images = await hUser.getUserImages();
                    if (images.hasOwnProperty('user_profile') && images.user_profile.uuid) {
                        $scope.userProfileDetails.profileImage = images.user_profile.uuid;
                    }
                } catch (error) {
                    console.error('Error getting user images:', error);
                }
            }

            $scope.toggleForm = (form) => {
                $scope.formTabClicked = form;
                if (form === 'SIGNUP') {
                    $scope.signUpFormIsVisible = true;
                    $scope.loginFormIsVisible = false;
                } else if (form === 'LOGIN') {
                    $scope.signUpFormIsVisible = false;
                    $scope.loginFormIsVisible = true;
                }
            };

            $scope.submitEmail = (isSubmitApplication) => {
                $scope.isCheckingLoginValidation = true;
                $scope.isEmailSubmitted = false;
                return new Promise((resolve, reject) => {
                    $scope.addEmailForm.validator.validate((isValid) => {
                        if (isValid) {
                            $scope.isEmailFormValid = true;
                            $scope.addEmailForm.save()
                                .then(() => {
                                    $scope.addEmailForm.visible = false;
                                    delete $scope.addEmailForm;
                                    $scope.isEmailSubmitted = true;
                                    if (!isSubmitApplication) {
                                        runTasks([
                                            doBeforeApplication,
                                            checkAppRequirements,
                                            doApply,
                                            doAfterApply
                                        ]);
                                    }
                                    resolve();
                                })
                                .catch((err) => {
                                    console.error('err', err);
                                    reject(err);
                                })
                                .finally(() => {
                                    $scope.isCheckingLoginValidation = false;
                                    $scope.$digest();
                                });
                        } else {
                            $scope.isCheckingLoginValidation = false;
                            $scope.isEmailFormValid = false;
                            resolve();
                        }
                    });
                });
            }

            const checkUser = (next)=> {
                if (hUser.isLoggedIn()) {
                    if (!hUser.data.user.email) {
                        $scope.userHasNoEmail = true;
                        $scope.addEmailForm = new AddEmailForm($scope);
                        $scope.addEmailForm.visible = true;
                    }
                }
                else {

                    var userLoggedInBefore = HStorageManager.get({
                        key: 'is_user',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    })


                    var isGDPREnabled = $scope.jobDetails.brand.public_services && $scope.jobDetails.brand.public_services.indexOf('GDPR') > -1;

                    $scope.signUpForm = new SignUpForm($scope, hUser, $scope.jobDetails.brand, $scope.jobDetails.job.id, localize, httpHelper, referrer, 'SINGLE_APPLY');
                    $scope.signUpSocialLinksForm = new SignUpSocialLinksForm($scope, hUser, $scope.jobDetails.brand, $scope.jobDetails.job.id, localize, httpHelper, referrer);
                    $scope.signUpForm.setSource('qr');
                    $scope.signUpForm.setFirstName(applicantFirstName);
                    $scope.signUpForm.setLastName(applicantLastName);
                    $scope.signUpForm.setJobType($scope.jobDetails.job['job_application_type']);
                    $scope.signUpForm.showGDPRDisclaimer(isGDPREnabled);
                    $scope.signUpForm.setQuickApplyStatus($scope.jobDetails.brand.public_services && $scope.jobDetails.brand.public_services.indexOf("NO_PASSWORD_QUICK_APPLY") > -1);

                    var devBrandId = 507259;
                    var liveBrandId = 6446489;
                    $scope.showOptInMessagesCb = [liveBrandId, devBrandId].indexOf($scope.jobDetails.top_parent_brand.id) > -1;
                    $scope.signUpForm.showOptInMessagesCheckbox($scope.showOptInMessagesCb);

                    if (userLoggedInBefore || resetPasswordCode || $stateParams.showLogin) {
                        $scope.loginFormVisible = true;
                        $scope.loginFormIsVisible = true;
                    }
                     else if (!$stateParams.showLogin){
                        $scope.signUpForm.visible = true;
                        $scope.signUpFormIsVisible = true;
                        $scope.formTabClicked = "SIGNUP";
                    }
                    if($scope.signUpForm.visible && $stateParams.showLogin){
                        setTimeout(function () {
                            $('.login-options').find('button')[0].focus();
                        },600);
                    }

                    $scope.goToSignUp = function () {
                        delete $scope.loginFormVisible;
                        $scope.signUpForm.visible = true;
                        $scope.signUpFormIsVisible = true;
                        $(APPLY_MODAL_SELECTOR).scrollTop(0);
                        setTimeout(function () {
                            $('.login-options').find('button')[0].focus();
                        },200);
                    };

                    $scope.handleLogin = async function (userData) {
                        try {
                            await hUser.getFullUserData();
                            hUser.login();
                            const placeholderToken = HStorageManager.get({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'placeholder_token'
                            });
                            if (placeholderToken) {
                                try {
                                    await jobApplyFactory.getCandidateApplyStatus($scope.jobDetails.brand.id);
                                    await UserAPI.confirmUserPlaceholderToken(placeholderToken);
                                    HStorageManager.remove({
                                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                        key: 'placeholder_token'
                                    });
                                    draftedBeforeApply = false;
                                } catch (error) {
                                    if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                        hAlert(
                                            $filter("translate")("Error"),
                                            jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                            () => {
                                                delete $scope.jobDetails?.job?.application_id;
                                                endApplication(jobApplyAPI.DISCARDED);
                                            }
                                        );
                                        return;
                                    } else {
                                        if (error?.data?.data?.code === jobApplyFactory.ERRORS.USER_ALREADY_APPLIED || error?.data?.data?.code === jobApplyFactory.ERRORS.USER_ALREADY_EXISTS_ON_TALENT_POOL) {
                                            $scope.userHasAlreadyApplied = true;
                                        }
                                        handleErrors(jobApplyFactory.ERRORS.USER_ALREADY_APPLIED, error);
                                    }
                                    $scope.$digest();
                                }
                                await doSubmitApplication($scope.next, $scope.applicationId);
                            }
                            formsSavedCallback();
                            await getLoggedInUserDetails();
                            $scope.$digest();
                            HStorageManager.remove({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'placeholder_token'
                            });
                            return Promise.resolve("Login successful.");
                        } catch (error) {
                            console.error("Login process failed:", error);
                            return Promise.reject(error);
                        }
                    };

                    $scope.onCustomChallenge = function(challenge) {
                        if(challenge) {
                            $scope.isCredentialled = true;
                            $scope.$digest();
                        }
                    }

                    $scope.signUpForm.goToLogin = function () {
                        delete $scope.signUpForm.visible;
                        $scope.loginFormVisible = true;
                        $(APPLY_MODAL_SELECTOR).scrollTop(0);
                    };

                    let socialLoginHandler = $scope.$on('logged-in-from-oauth', async (event, provider, userData) => {
                        $scope.hasSignedSocialWithLink = true;
                        const placeholderToken = HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'placeholder_token'
                        });
                        if (placeholderToken) {
                            try {
                                await jobApplyFactory.getCandidateApplyStatus($scope.jobDetails.brand.id);
                                await UserAPI.confirmUserPlaceholderToken(placeholderToken);
                                HStorageManager.remove({
                                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                    key: 'placeholder_token'
                                });
                                draftedBeforeApply = false;
                            } catch (error) {
                                if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                    hAlert(
                                        $filter("translate")("Error"),
                                        jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                        () => {
                                            delete $scope.jobDetails?.job?.application_id;
                                            endApplication(jobApplyAPI.DISCARDED);
                                        }
                                    );
                                    return;
                                } else {
                                    handleErrors(jobApplyFactory.ERRORS.USER_ALREADY_APPLIED, error);
                                }
                                $scope.$digest();
                            }
                        }

                        hUser.login(userData);
                        if (hUser.isLoggedIn() && !hUser.data.user.email) {
                            $scope.userHasNoEmail = true;
                            $scope.addEmailForm = new AddEmailForm($scope);
                            $scope.addEmailForm.visible = true;
                            delete $scope.processing;
                        }
                        next();

                        // Unsubscribe to social login event
                        socialLoginHandler();

                        $scope.loginFormVisible = false;
                        delete $scope.formTabClicked;
                        delete $scope.signUpForm;

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);

                        // Track login to analytics
                        $scope.trackEvent('user_login', {
                            'label': provider
                        });
                    });

                    var formsSavedCallback = function () {
                        var type =  $scope.loginFormVisible? 'LOGIN': 'REGISTER';

                        if (resetPasswordCode) {
                            $state.go('.', { code: null }, false);
                            type = 'PASSWORD_RESET';
                        }

                        $scope.loginFormVisible = false;
                        delete $scope.signUpForm;

                        $scope.trackEvent('user_login', {
                            'label': type
                        });

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    };

                    $scope.signUpForm.onFormSaved(formsSavedCallback);
                }
                next();
            };

            var doBeforeApplication = function (next) {

                if (!$scope.userHasNoEmail) {
                    $scope.processing = $filter("translate")("Loading Application");
                }

                $('body').addClass('modal-open');

                if ($scope.jobDetails.job.application_id &&
                    (!$scope.jobDetails.job.can_reapply ||
                        ($scope.jobDetails.job.can_reapply && $scope.jobDetails.job.jobApplicationMode === 'REAPPLY'))) {
                    draftedBeforeApply = true;
                    if ($scope.jobDetails.job.applied_date) {
                        $scope.isApplied = true;
                    }
                    else if ($scope.jobDetails.job.deleted) {
                        endApplication(JobDetailsBus.EXPIRED);
                    } else {
	                    next($scope.jobDetails.job.application_id);
                    }
                }
                else {
                initRecaptcha()
                  .finally(()=>{
                    hRecaptchaUtil.execute(`create_draft_application`)
                        .then(function (gRecaptchaResponse) {
                            const isPrivateLink = $state.current.isPrivateLink;

                            let promises = {};

                            if (hUser.isLoggedIn()) {
                                promises['candidate_status'] = jobApplyFactory.getCandidateApplyStatus($scope.jobDetails.brand.id);
                            }

                            $q.all(promises).then((res) => {
                                // create draft and get application id
                                JobApplicationAPI.createDraftApp(jobId, isPrivateLink, gRecaptchaResponse).then((draft) => {
                                    $scope.jobDetails.job.application_id = draft.application_id;
                                    $scope.jobDetails.job.jobApplicationMode = draft.job_application_mode;

                                    if (draft.applied_date) {
                                        $scope.jobDetails.job.applied_date = draft.applied_date;
                                        $scope.isApplied = true;
                                        JobDetailsBus.onJobApplyUpdate(JobDetailsBus.APPLIED, draft.application_id, draft.applied_date);

                                        setTimeout(() => {
                                            $scope.$digest();
                                        }, 1);
                                    } else {
                                        draftedBeforeApply = !draft.new;

                                        if (draftedBeforeApply) {
                                            JobDetailsBus.onJobApplyUpdate(JobDetailsBus.DRAFTED, draft.application_id);
                                        }

                                        $scope.placeholderUserId = draft?.user_id

                                        if (draft.placeholder_token) {
                                                HStorageManager.put({
                                                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                                    key: 'placeholder_token',
                                                    value: draft.placeholder_token
                                                });
                                        }

                                        next(draft.application_id);
                                    }
                                }, (err) => {
                                    handleErrors("CREATE_DRAFT", err);
                                });
                            }).catch((error) => {
                                if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                    hAlert(
                                        $filter("translate")("Error"),
                                        jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                        () => {
                                            delete $scope.jobDetails?.job?.application_id;
                                            endApplication(jobApplyAPI.DISCARDED);
                                        }
                                    );
                                }
                            })
                        });
             });
                }
            };

            let registerUser = () => {
                return new Promise(async (resolve, reject) => {
                    try {
                        if ($scope.formTabClicked === 'SIGNUP') {
                            await $scope.signUpForm.doSignUp();
                            resolve();
                        } else {
                            resolve();
                        }
                    } catch (error) {
                        reject(error);
                    }
                });
            };

            let validateLoginTabForms = () => {
                const allForms = forms.getForms();
                const profilePhotoForm = allForms.find(form => form.name === "profile-photo-form");
                if (profilePhotoForm) {
                    forms.deleteForm(profilePhotoForm);
                }
                const jobApplyDisclaimerForm = allForms.find(form => form.name === "job-apply-disclaimer-form");
                if (jobApplyDisclaimerForm) {
                    const hasJobApplyConsent = applicationDetails.disclaimers?.some(disclaimer => disclaimer.type === 'JOB_APPLY_CONSENT');
                    if (!applicationDetails.disclaimers || !hasJobApplyConsent) {
                        forms.deleteForm(jobApplyDisclaimerForm);
                    }
                }
                return forms.validateAll();
            }

            $scope.isLoginFormValidated = async (isCreditsValid) => {
                $scope.isCheckingLoginValidation = false;
                $scope.$digest();
                if (isCreditsValid) {
                    $scope.triggerLogin = !$scope.triggerLogin;
                    $scope.processing = $filter("translate")("Submitting Your Application");
                    $(APPLY_MODAL_SELECTOR).scrollTop(0);
                    $scope.$digest();
                } else {
                    handleValidationError();
                }
            };

            $scope.loggedInHandler = async (isValid) => {
                if (isValid) {
                    await hUser.getFullUserData();
                    hUser.login();
                } else {
                    delete $scope.processing;
                    $scope.$digest();
                    handleValidationError();
                }
            };

            const handleValidationError = () => {
                setTimeout(() => {
                    $(APPLY_MODAL_SELECTOR).scrollTo($(".error:visible:first").parent());
                    $(".error:visible:first").parent().find('input')[0].focus();
                }, 500);
            }

            const checkAppRequirements = async (next, applicationId) => {
                if (hUser.isLoggedIn()) {
                    await getLoggedInUserDetails();
                }

                const placeholderToken = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'placeholder_token'
                });
                JobApplicationAPI.getAppDetails(applicationId, placeholderToken)
                    .then(function (application) {
                        applicationDetails = application;
                        applicationDetails.id = applicationId;
                        $scope.isEducationDatesMandatory = application.is_education_dates_mandatory;

                        if (applicationDetails.screening_forms && applicationDetails.screening_forms.length) {
                            $scope.applicationEEOForm = _.findWhere(applicationDetails.screening_forms, {type: "EEO"});
                        }

                        const applicationOptions = application.job_application_options;
                        if (!$scope.hasSignedSocialWithLink) {
                            $scope.formsToFill = [];
                            $scope.formsToFill = $scope.formsToFill.concat(applicationOptions.options);
                        }

                        if (!$scope.formsToFill.length) {
                            next(applicationId);
                        }
                        else {
                            if (!$scope.hasSignedSocialWithLink) {
                                prepareApplicationForms(applicationId);
                            } else {
                                prepareSignedWithLinkApplicationForms(applicationOptions.options);
                            }

                            $scope.submitApplication = async () => {
                                try {
                                    const isLoginTab = $scope.formTabClicked === 'LOGIN';
                                    const isSignUpTab = $scope.formTabClicked === 'SIGNUP';
                                    const isLoggedIn = hUser.isLoggedIn();

                                    if (isLoggedIn) {
                                        HStorageManager.remove({
                                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                            key: 'placeholder_token'
                                        });
                                        const allForms = forms.getForms();
                                        const profilePhotoForm = allForms.find(form => form.name === "profile-photo-form");
                                        if (profilePhotoForm) {
                                            forms.deleteForm(profilePhotoForm);
                                        }
                                        const jobApplyDisclaimerForm = allForms.find(form => form.name === "job-apply-disclaimer-form");
                                        if (jobApplyDisclaimerForm) {
                                            const hasJobApplyConsent = applicationDetails.disclaimers?.some(disclaimer => disclaimer.type === 'JOB_APPLY_CONSENT');
                                            if (!applicationDetails.disclaimers || !hasJobApplyConsent) {
                                                forms.deleteForm(jobApplyDisclaimerForm);
                                            }
                                        }
                                        $scope.isEmailFormValid = true;
                                        if ($scope.userHasNoEmail && $scope.addEmailForm) {
                                            await $scope.submitEmail(true);
                                        }
                                        if (forms.validateAll() && $scope.isEmailFormValid) {
                                            await doSubmitApplication(next, applicationId);
                                            $scope.$digest();
                                        } else {
                                            handleValidationError();
                                        }
                                    }
                                    else if (isLoginTab) {
                                        if (validateLoginTabForms()) {
                                            $scope.isCheckingLoginValidation = true;
                                            $scope.runValidate = !$scope.runValidate;
                                            $scope.next = next;
                                            $scope.applicationId = applicationId;
                                        } else {
                                            handleValidationError();
                                        }
                                    } else if (isSignUpTab) {
                                        const isSignUpFormValid = await $scope.signUpForm.doValidation();
                                        const allForms = forms.getForms();
                                        const jobApplyDisclaimerForm = allForms.find(form => form.name === "job-apply-disclaimer-form");
                                        if (jobApplyDisclaimerForm) {
                                            const hasJobApplyConsent = applicationDetails.disclaimers?.some(disclaimer => disclaimer.type === 'JOB_APPLY_CONSENT');
                                            if (!applicationDetails.disclaimers || !hasJobApplyConsent) {
                                                forms.deleteForm(jobApplyDisclaimerForm);
                                            }
                                        }
                                        if (forms.validateAll() && isSignUpFormValid) {
                                            await doSubmitApplication(next, applicationId);
                                            $scope.$digest();
                                        } else {
                                            handleValidationError();
                                        }
                                    }
                                    $scope.$digest();
                                } catch (error) {
                                    delete $scope.processing;
                                    handleErrors("SAVE_FORMS", error);
                                }
                            }
                            delete $scope.processing;
                            $scope.$digest();
                        }
                    }, function (error) {
                        handleErrors("LOAD_APP_DETAILS", (error && error.data));
                    });
            };

            const checkEEOQuestionsSettings = async (next, applicationId) => {
                if ($scope.jobDetails.brand?.public_services?.includes("EQUAL_EMPLOYMENT_OPPORTUNITY")) {
                    const params = {
                        job_ids: jobId
                    };
                    const response = await EEOAPI.getEeoQuestionsCandidateSettings($scope.jobDetails.brand.id, 'EQUAL_EMPLOYMENT_OPPORTUNITY', params);

                    $scope.eeoForms = response.forms;
                }

                next(applicationId);
            };

            let prepareSignedWithLinkApplicationForms = (options) => {
                const validFormsCodes = options.map(option => option.code);
                $scope.formsToFill = $scope.formsToFill.filter(form => validFormsCodes.includes(form.code));

                Object.keys($scope.applicationForms)
                    .filter(key => !validFormsCodes.includes(key))
                    .forEach(key => {
                        const form = $scope.applicationForms[key];
                        if (form) {
                            forms.deleteForm(form);
                        }
                        delete $scope.applicationForms[key];
                    });
            };

            let doSubmitApplication = async (next, applicationId) => {
                if (hUser.isLoggedIn() || $scope.formTabClicked === 'SIGNUP') {
                    $scope.processing = $filter("translate")("Submitting Your Application");
                    $(APPLY_MODAL_SELECTOR).scrollTop(0);
                }
                if ($scope.formTabClicked === 'SIGNUP') {
                    await registerUser();
                }
                try {
                    await jobApplyFactory.getCandidateApplyStatus($scope.jobDetails.brand.id);
                } catch (error) {
                    if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                        hAlert(
                            $filter("translate")("Error"),
                            jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                            () => {
                                delete $scope.jobDetails?.job?.application_id;
                                endApplication(jobApplyAPI.DISCARDED);
                            }
                        );
                        return;
                    }
                }

                if (hUser.isLoggedIn() && !hUser.data.user.email && !$scope.isEmailSubmitted) {
                    $scope.userHasNoEmail = true;
                    $scope.addEmailForm = new AddEmailForm($scope);
                    $scope.addEmailForm.visible = true;
                    delete $scope.processing;
                } else if (!$scope.userHasAlreadyApplied) {
                    try {
                        await forms.saveAll();
                        next(applicationId);
                        $scope.$digest();
                    } catch (error) {
                        delete $scope.processing;
                        handleErrors("SAVE_FORMS", error);
                        $scope.$digest();
                    }
                }
            }

            var doApply = function (next, applicationId) {
                $scope.processing = $filter("translate")("Submitting Your Application");

                var applyDisclaimerConsent;

                if ($scope.applicationForms['JOB_APPLY_DISCLAIMER']) {
                    applyDisclaimerConsent = $scope.applicationForms['JOB_APPLY_DISCLAIMER'].data['disclaimer_consent'];
                }

                JobApplicationAPI.save({
                    id: applicationId,
                    applyDisclaimerConsent: applyDisclaimerConsent,
                    job_referrer_id: job_referrer_id,
                    referrer: referrer,
                    social_media_channel: social_media_channel,
                    talent_scout_code_id: talent_scout_code_id
                }, 'active', $state.current.isPrivateLink, $state.current.isPrivateViaLinkJob)
                    .then(function (applyData) {
                        delete $scope.processing;

                        if (applyData.privacy_shield_applied) {
                            hUser.setPrivacyShield(true);
                        }

	                    next(applicationId);

                        $scope.trackEvent('submit', { 'label': getFormsAsCodeString() });
                        $scope.$digest();
                    }, function (error) {
	                    delete $scope.processing;
                        handleErrors("APPLY", error);
                        $scope.$digest();
                    });
            };

            var doAfterApply = function (next, applicationId) {
                $scope.jobDetails.job.applied_date = Date.now();
                retryCounter = 0;

                if (typeof HThirdPartyManager !== 'undefined') {
                    // Register all tracking pixels and services
                    HThirdPartyManager.register(HStoragePolicyManager.Categories.ANALYTICS, function() {
                        try {
                            // Run tracking pixels for external services
                            TrackingPixels['Glassdoor'].track();
                            TrackingPixels['Indeed'].track();
                            TrackingPixels['Jobs2Careers'].track();
                            krtMarketingTrackingService.trackApplicationSent(jobId, $stateParams.pjt);
                            googleTagManagerTrackingService.trackApplicationCompletion(jobId);
                        } catch (err) { console.error(err); }

                        if (typeof(__clickIq) !== 'undefined') {
                            try {
                                __clickIq.TrackApplication("https://api.clickiq.co.uk", publicConfiguration.MandBClickIQClientKey, jobId);
                            } catch (err) { console.error(err); }
                        }
                    }, 'application_tracking_pixels');
                }

                if (hUser.data.user.status === "DRAFT_NO_PASSWORD" && $scope.jobDetails.brand.public_services && $scope.jobDetails.brand.public_services.indexOf("NO_PASSWORD_QUICK_APPLY") > -1) {
                    endApplication(JobDetailsBus.SUCCESS_NO_PASSWORD, applicationId, applicationDetails.applied_date);
                } else {
                    endApplication(JobDetailsBus.SUCCESS, applicationId, applicationDetails.applied_date);
                }
            };

            var showLocationWarning = function (jobLocation, distance, next) {
                $modal({
                    controller: 'FarJobModalController',
                    templateUrl: '../modules/job_apply/views/far_job_location.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return {
                                city: (jobLocation.city && jobLocation.city.name) || jobLocation.formatted_address,
                                distance: Math.round(distance)
                            };
                        },
                        onAccept: function () {
                            return function (data) {
                                HStorageManager.put({
                                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                    key: 'job_distance_{{id}}',
                                    value: true,
                                    variables: {
                                        id: jobId
                                    }
                                });
	                            next();
                                setTimeout(function () {
                                    $(".close")[0].focus();
                                }, 500);
                                $scope.trackEvent('far_job', { 'label': 'accept' });
                            }
                        },
                        onDiscard: function () {
                            return function (data) {
                                HStorageManager.put({
                                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                    key: 'job_distance_{{id}}',
                                    value: false,
                                    variables: {
                                        id: jobId
                                    }
                                });
                                endApplication(JobDetailsBus.DISCARDED);
                                $scope.trackEvent('far_job', { 'label': 'discard' });
                            }
                        }
                    }
                });
            };

            var getParsedData = function (parsedData) {

                if (parsedData) {
                    if ($scope.applicationForms['EDUCATION'] && parsedData.education && parsedData.education.length) {
                        var educationForm = $scope.applicationForms['EDUCATION'];
                        educationForm.parseEducation(parsedData.education);
                        setTimeout(educationForm.validator.validate, 500);
                    }

                    if ($scope.applicationForms['WORK_HISTORY'] && parsedData.work_history && parsedData.work_history.length) {
                        var experienceForm = $scope.applicationForms['WORK_HISTORY'];
                        experienceForm.parseWorkHistory(parsedData.work_history);
                        setTimeout(experienceForm.validator.validate, 500);
                    }

                    if ($scope.applicationForms['PHONE']) {
                        var basicInfoForm = $scope.applicationForms['PHONE'];

                        if (!basicInfoForm.data.phone) {
                            basicInfoForm.data.phone = parsedData.phone;
                            setTimeout(basicInfoForm.validator.validate, 500);
                        }
                    }

                    if ($scope.applicationForms['REFERENCES'] && parsedData.references && parsedData.references.length) {
                        var referencesForm = $scope.applicationForms['REFERENCES'];
                        referencesForm.data.references = parsedData.references;
                        setTimeout(referencesForm.validator.validate, 500);
                    }

                    if ($scope.applicationForms['SKILLS'] && parsedData.skills && parsedData.skills.length) {
                        var skillsForm = $scope.applicationForms['SKILLS'];
                        skillsForm.data.skills = parsedData.skills;
                        setTimeout(skillsForm.validator.validate, 500);
                    }
                }

            };

            var checkResumeRequirements = function () {
                // Add resume, and enable parse if work history or education is required
                if ($scope.applicationForms['WORK_HISTORY'] || $scope.applicationForms['EDUCATION']) {
                    if (!$scope.applicationForms['RESUME']) {
                        $scope.formsToFill = [{ 'code': 'RESUME', 'is_optional': true, 'rank': 1 }].concat($scope.formsToFill);
                        var form = new ResumeUploadForm($scope, Upload, applicationDetails.id, hUser, $scope.jobDetails.job);
                        form.type = 'job_application';
                        form.setRequired(false);
                        form.templateURL = "../modules/hforms/resume_upload/views/resume_upload_form.html";
                        form.getParsedData = getParsedData;
                        $scope.applicationForms['RESUME'] = form;
                        forms.addForm(form);
                    }

                    $scope.applicationForms['RESUME'].allowParse(true);
                }
            };

            setTimeout(function () {
                startApplication();
            }, 1);

            $scope.$on('$destroy', function () {
                $('body').removeClass('modal-open');
                unhookTransitionStart();
                dFCarriEvent && chatBotService.off(dFCarriEvent);
                
                // Unregister tracking pixels
                if (typeof HThirdPartyManager !== 'undefined') {
                    HThirdPartyManager.unregister(HStoragePolicyManager.Categories.ANALYTICS, 'application_tracking_pixels');
                    HThirdPartyManager.unregister(HStoragePolicyManager.Categories.ANALYTICS, 'application_start_tracking');
                }
            });

            var unhookTransitionStart = hTransitions.onStart({}, function (trans) {
                var toState = trans.to();
                var fromState = trans.from();
                var toParams = trans.params('to');

                if (applicationDetails && !discardApproved) {

                    // Don't count this change in PerformanceUtils
                    PerformanceUtils.reset();

                    if (toState.name != fromState.name) {

                        stateToGoAfterDiscard = toState.name;
                        paramsToGoAfterDiscard = toParams;

                        $scope.cancelApplication();

                        // Transition prevented
                        return false;
                    }
                }
            });
        }
    ]);

    var APPLY_MODAL_SELECTOR = "#job_apply_modal";
    var CANCEL_MODAL_SELECTOR;

    var runTasks = function (tasks, index, previousResult) {
        index = index || 0;

        tasks[index](function (res, err) {

            if (err) {
                console.error(err);
                return;
            }

            if (tasks[(index + 1)]) {
                runTasks(tasks, (index + 1), res);
            }

            $(APPLY_MODAL_SELECTOR).scrollTop(0);
        }, previousResult);
    };


    var TrackingPixels = {};
    /**
     * Beginning of Glassdoor Application Tracking Code to track users apply
     * not that there is an image should be injected in the view
     * <noscript><img src="//www.glassdoor.com/track/jobApply/complete.htm?partnerId=6176" width="1" height="1" border="0"></noscript>
     */
    TrackingPixels['Glassdoor'] = {
        track: function () {

            var imgId = 'glassdoor-tracking-script';
            var tr = new Date().getTime();
            var sys = '';
            var syscli = '';

            var img = $('<img id="' + imgId + '">');
            img.attr('src', 'https://www.glassdoor.com/track/jobApply/complete.htm?partnerId=6176&sys=' + sys + '&syscli=' + syscli + '&cachebuster=' + tr);
            img.attr('width', '1');
            img.attr('height', '1');
            //delet from DOM
            $('#' + imgId).remove();
            //append to DOM
            img.appendTo('body');
        }
    };

    /**
     * Indeed Tracking script
     * an image will injected into the DOM
     * ticket: HARRI-5609
     */
    TrackingPixels['Indeed'] = {
        track: function () {

            var imgId = 'indeed-tracking-script';
            var img = $('<img id="'+imgId+'">');
            img.attr('src','https://conv.indeed.com/pagead/conv/2316554886956775/?script=0');
            img.attr('width', '1');
            img.attr('height', '1');
            //delet from DOM
            $('#'+imgId).remove();
            //append to DOM
            img.appendTo('body');
        }
    };

    /**
     * Jobs2Careers Script
     * an image will injected into the DOM
     * ticket: HARRI-8579
     */
    TrackingPixels['Jobs2Careers'] = {
        track: function () {

            var imgId = 'jobs-2-careers-script';
            var img = $('<img id="'+imgId+'">');
            img.attr('src','//www.jobs2careers.com/conversion2.php?p=2427');
            img.attr('width', '1');
            img.attr('height', '1');
            //delete from DOM
            $('#'+imgId).remove();
            //append to DOM
            img.appendTo('body');
        }
    };

})(angular.module('harriApp'));
